<common-card>
  <common-card-header>
    <div class="row no-gutters">
      <div class="col-auto mr-2">
        <nb-icon
          icon="clipboard-list"></nb-icon>
      </div>
      <div class="col">
        <h6>
          {{'modules.valet.valet_profile.withholdings.title' |translate}}
        </h6>
      </div>
    </div>
  </common-card-header>
  <common-card-body>
    <div class="row">
      <div class="col-auto">
        <button nbButton (click)="createWithholding()">
          {{'modules.valet.valet_profile.withholdings.add_withholding' | translate}}
        </button>
      </div>
      <div class="col-auto ml-auto text-right">
        {{'modules.valet.valet_profile.withholdings.available_remuneration_amount' | translate}}
        <ng-container *ngTemplateOutlet="amount; context:{amount: availableRemunerationAmount}"></ng-container><br>
        {{'modules.valet.valet_profile.withholdings.available_expense_amount' | translate}}
        <ng-container *ngTemplateOutlet="amount; context:{amount: availableExpenseAmount}"></ng-container><br><hr>
        {{'modules.valet.valet_profile.withholdings.available_total_amount' | translate}}
        <ng-container *ngTemplateOutlet="amount; context:{amount: availableTotalAmount}"></ng-container>
      </div>
    </div>
    <pv-custom-list-layout
      [hideTitle]="true"
      [hideFilters]="true"
      [hideInfos]="true"
      [hideTabs]="true"
      [storageKey]="'adminDocumentTypeGrid'"
      [showColumnSettings]="showColumnSettings"
      [columnSettings]="columnSettings"
      [buttonsConfig]="buttonsConfig"
      (columnVisibilityChanged)="onColumnVisibilityChanged($event)"
      (refreshClicked)="onRefresh()"
      (exportClicked)="onExportPageData()">

      <!-- Table Content -->
      <div content>
        <pv-custom-list
          [columns]="columns"
          [dataSource]="this"
          [isLoading]="isLoading">
        </pv-custom-list>
      </div>
    </pv-custom-list-layout>

    <ng-template #totalAmountTemplate let-row>
        {{ formatAmount(row.totalAmount) }}
    </ng-template>

    <ng-template #remainingAmountTemplate let-row>
        {{ formatAmount(row.remainingAmount) }}
    </ng-template>

    <ng-template #allowInExpensesTemplate let-row>
        {{ formatAllowInExpenses(row) }}
    </ng-template>

    <ng-template #actionsTemplate let-row>
        <div class="d-flex justify-content-center">
        <pv-link-display-column
          style="margin-right: 1rem;"
          [icon]="'edit'"
          [customAction]="updateWithholding"
          [rowData]="row"
          [status]="'info'">
        </pv-link-display-column>
        <pv-link-display-column
          [icon]="'trash'"
          [customAction]="deleteWithholding"
          [rowData]="row"
          [status]="'danger'"
        ></pv-link-display-column>
      </div>
    </ng-template>
  </common-card-body>
</common-card>

<ng-template #amount let-amount="amount">
  <ng-container *ngIf="amount !== null"><strong>{{formatAmount(amount)}}</strong></ng-container>
  <ng-container *ngIf="amount === null">?</ng-container>
</ng-template>
